<template>
  <v-card>
    <v-list-item
        dark
        class="indigo"
    >
      <v-list-item-avatar>
        <v-icon>
          mdi-email-multiple
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">Courier History</v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn icon @click.prevent="minimize = !minimize">
          <v-icon v-if="!minimize">mdi-chevron-up</v-icon>
          <v-icon v-else>mdi-chevron-down</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <v-sheet class="tracking-search pa-4 indigo lighten-1" v-if="!minimize">
      <v-text-field
          v-model="search"
          label="Search package"
          dark
          flat
          solo-inverted
          hide-details
          clearable
          clear-icon="mdi-close"
      >
        <template v-slot:append-outer>
          <courier-history-add-dialog :id="id" @success="fetchData"></courier-history-add-dialog>
        </template>
      </v-text-field>
    </v-sheet>
    <v-card-text v-if="!minimize">
      <v-list>
        <v-list-item
            class="px-0"
            v-for="item in filtered"
            :key="item.id"
            :three-line="item.desciption"
            :two-line="!item.desciption"
        >
          <v-list-item-avatar>
            <v-icon v-if="item.from_agent">mdi-email-send</v-icon>
            <v-icon v-else>mdi-email-receive</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title><a :href="trackingUrl(item)" target="_blank">{{ item.tracking }}</a> via {{
                item.courier
              }}
            </v-list-item-title>
            <v-list-item-subtitle v-text="item.description"></v-list-item-subtitle>
            <v-list-item-subtitle>{{ item.created | formatISO }}</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon @click.stop="deleteTracking(item)">
              <v-icon color="grey">mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>

        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>
<script>
import moment from 'moment'
import CourierHistoryAddDialog from './AddDialog'
import {errorNotification} from "@/components/utils";

export default {
  components: {CourierHistoryAddDialog},
  name: 'ApplicationCourierHistory',
  props: {
    id: Number
  },
  data() {
    return {
      search: '',
      minimize: false,
      courierHistory: []
    }
  },
  computed: {
    filtered() {
      return this.courierHistory.filter((item) => (item.tracking.indexOf(this.search) > -1 || item.description.indexOf(this.search) > -1))
    }
  },
  filters: {
    formatISO(date) {
      return moment(date).format('YYYY-MM-DD')
    },
  },
  methods: {
    fetchData() {
      this.$axios.get('/applications/' + this.id + '/courier/', {})
          .then((response) => {
            this.courierHistory = response.data
          })
          .catch((error) => {
            errorNotification(error)
          })
    },
    deleteTracking(tracking) {
      this.$root.$confirm('Delete', 'Are you sure you want to delete tracking number?', {color: 'red'}).then((confirm) => {
        if (confirm) {
          this.$axios.delete('/application/courier/history/' + tracking.id + '/', {})
              .then(() => {
                let index = this.courierHistory.indexOf(tracking)
                this.courierHistory.splice(index, 1)
              })
              .catch((error) => {
                errorNotification(error)
              })
        }
      })
    },
    trackingUrl(item) {
      switch (item.courier) {
        case 'FEDEX':
          return 'https://www.fedex.com/apps/fedextrack/?action=track&trackingnumber=' + item.tracking
        case 'DHL':
          return 'https://www.dhl.com/en/express/tracking.html?AWB=' + item.tracking + '&brand=DHL'
      }
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.tracking-search {
  border-top-left-radius: 0;
  border-top-right-radius: 0;

  .v-input__append-outer {
    margin-top: 4px !important;
  }
}
</style>